var EXPAND_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    EXPAND: 'EXPAND',
    FADE_IN: 'FADE_IN',
    ZOOM: 'ZOOM',
};
export default EXPAND_ANIMATIONS;
//# sourceMappingURL=expandAnimations.js.map